import { render } from "./pendingorderSvg.vue?vue&type=template&id=3c77a408"
import script from "./pendingorderSvg.vue?vue&type=script&lang=js"
export * from "./pendingorderSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__